import React, { useState, useEffect } from "react";
import Navigation from "./navigation/mainNavBar";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import CountUp from "react-countup";
import { Helmet } from "react-helmet-async";
import "./App.scss";

import Footer from "./footer/Footer";

import Discord from "./Discord";
import Gallery from "./Gallery";

function App() {
  const [mainStatisticsData, setMainStatisticsData] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies(["accept-cookies"]);

  useEffect(() => {
    if (!cookies["accept-cookies"]) {
      return () => {};
    }
    const cacheTime = 30000; // 30 sekund
    const cachedData = localStorage.getItem("mainStatisticsData");
    const cachedTime = localStorage.getItem("lastMainFetchTime");
    const currentTime = Date.now();

    if (cachedData && cachedTime && currentTime - cachedTime < cacheTime) {
      setMainStatisticsData(JSON.parse(cachedData));
      // console.log("tutaj jest cachedData");
    } else {
      fetch("./requestMainStatistics.php", {
        // credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("tutaj jest data");
          setMainStatisticsData(data);
          localStorage.setItem("mainStatisticsData", JSON.stringify(data));
          localStorage.setItem("lastMainFetchTime", Date.now());
        });
    }
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = document.hidden
        ? "Wróć do nas!!🤠"
        : "WildLandsRP.pl - Polski Serwer RP RDR2";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/application`;
    navigate(path);
  };

  const routeChange2 = () => {
    let path = `/rules`;
    navigate(path);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="App">





      <Navigation />
      <div className="content">
        <h1 className="title">WildLandsRP</h1>
        <h2 className="visually-hidden">
  WildLandsRP.pl - Polski serwer RedM RP w świecie Red Dead Redemption 2 RP i RDR2 Roleplay
</h2>
        <div className="sub-title">Przyjaciele, wrogowie i fortuna czekają na Ciebie!</div>
        <div className="main-butons-line"></div>
        <div className="main-buttons">
          <button className="rounded-button" onClick={routeChange}>
            Aplikuj
          </button>
          <button className="rounded-button" onClick={routeChange2}>
            Regulamin
          </button>
        </div>
      </div>
      <div className="section-title">Nastaje nowy ranek</div>
      <section className="grid">
      <div className="grid-item">
        <h3>O WildLandsRP</h3>
        <p>
          WildLandsRP.pl, znany także jako <strong>WildLandsRP</strong>, to <strong>polski serwer RedM RP</strong> w świecie 
          <strong> Red Dead Redemption 2</strong>. Dołącz do naszej społeczności i 
          rozpocznij niezapomnianą przygodę roleplay na Dzikim Zachodzie. 
          Oferujemy unikalne możliwości rozwoju postaci, realistyczną rozgrywkę 
          oraz aktywną administrację, która dba o klimat i dobrą zabawę.
        </p>
      </div>
        <div className="grid-item">
          <h3>Gospodarka</h3>
          Otwórz się na fascynujący świat gry, gdzie możesz handlować z innymi
          graczami i wyznaczać swoje ceny, by czerpać zyski z dostarczania
          towarów i usług. Nie tylko możesz wcielić się w postać wędrownego
          kupca lub kowboja, ale także zbudować swoją własną sieć sklepów, która
          zapewni Ci stabilny dochód. Przejmij kontrolę nad swoim życiem w grze
          i pozwól swojej wyobraźni swobodnie działać!
        </div>
        <div className="grid-item">
        <h3>Administracja i wsparcie graczy RDR RP</h3>
        <p>
          Nasza doświadczona ekipa administracji działa na serwerach już od ponad
          sześciu lat, wspierając fanów <strong>RDR RP</strong> i 
          <strong> Red Dead Redemption RP</strong>. Tworzymy przyjazną przestrzeń 
          dla graczy, którzy chcą zanurzyć się w klimacie dzikiego zachodu. 
          U nas każdy znajdzie swoje miejsce i będzie mógł swobodnie rozwijać 
          swoją postać, tworząc unikalne historie i doświadczenia w świecie 
          <strong> RDR2 RP</strong>.
        </p>
      </div>
      </section>
      <section className="grid5">
        <div className="grid-item2">
          <Gallery></Gallery>
        </div>
      </section>
      <section className="grid4">
        <div className="grid-item">
          <Discord></Discord>
        </div>
        <div className="grid-item">
          <h3>Komunikacja to podstawa</h3>
          Komunikacja jest kluczowa, aby móc budować silną i zorganizowaną
          społeczność. Dlatego też, chcielibyśmy zaprosić Cię do dołączenia do
          naszej rozwijającej się społeczności na serwerze Discord.Tam będziesz
          miał dostęp do wszystkich najnowszych informacji i ogłoszeń związanych
          z naszą społecznością.
          <br />
          <br />
          Nie tylko to, ale także zachęcamy Cię do angażowania się w interakcję
          z nami i innymi graczami! Wymieniaj się swoimi pomysłami, dziel się
          swoimi przemyśleniami, a także baw się dobrze w naszym towarzystwie.
          Nasz serwer to miejsce, w którym każdy gracz może znaleźć coś dla
          siebie.
          <br />
          <br />
          Dołącz już dziś do naszej społeczności i odkryj, jak wiele przygód
          czeka na Ciebie w świecie RDR2 Roleplay!
        </div>
      </section>

      <div className="section-title">Kilka Statystyk</div>
      <section className="grid">
        <div className="grid-item">
          <h3>Łączny majątek graczy w banku</h3>
          <h4>
            Suma pieniędzy, które gracze posiadają wirtualnie w banku gry.{" "}
            <br />
            <br />
            <CountUp
              end={mainStatisticsData.money}
              duration={5}
              delay={1}
              suffix="$"
              decimals={2}
            />
          </h4>
        </div>
        <div className="grid-item">
          <h3>Liczba gangów</h3>
          <h4>
            Ilość grup graczy, które tworzą zorganizowane gangi w grze.
            <br />
            <br />
            <CountUp end={mainStatisticsData.gangs} duration={5} delay={1} />
          </h4>
        </div>
        <div className="grid-item">
          <h3>Liczba obywateli</h3>
          <h4>
            Ilość mieszkańców naszego pieknego hrabstwa gry.
            <br />
            <br />
            <CountUp
              end={mainStatisticsData.characters}
              duration={5}
              delay={1}
            />
          </h4>
        </div>
      </section>
      <section className="grid">
        <div className="grid-item">
          <h3>Liczba wysłanych listów</h3>
          <h4>
            Ilość wiadomości, które gracze wysyłają między sobą w grze.
            <br />
            <br />
            <CountUp end={mainStatisticsData.letters} duration={5} delay={1} />
          </h4>
        </div>
        <div className="grid-item">
          <h3>Ilość sztuk broni na serwerze.</h3>
          <h4>
            Ilość różnych sztuk broni, które są dostępne dla graczy w grze.
            <br />
            <br />
            <CountUp end={mainStatisticsData.weapons} duration={5} delay={1} />
          </h4>
        </div>
        <div className="grid-item">
          <h3>Ilość wystawionych ogłoszeń.</h3>
          <h4>
            Liczba reklam, ofert handlowych i różnych ogłoszeń, które są
            publikowane w grze.
            <br />
            <br />
            <CountUp end={mainStatisticsData.pins} duration={5} delay={1} />
          </h4>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
